import { updateUserEditorData } from './helpers'
import { UserEditorDataAction } from './actions'
import { UserEditorData } from './types'

export interface State {
  userEditorData: Record<number, UserEditorData>
  errorMsg: string
  error: boolean
}

export const initialState: State = {
  userEditorData: {},
  errorMsg: '',
  error: false
}

export default (state = initialState, action: UserEditorDataAction): State => {
  switch (action.type) {
    case 'userEditorData.saveUserEditorDataFailure':
      return {
        ...state,
        errorMsg: action.payload.message ?? '',
        error: false
      }
    case 'userEditorData.saveUserEditorDataSuccess':
      return {
        ...state,
        errorMsg: action.payload.message,
        error: true
      }
    case 'userEditorData.addUserEditorData':
      return {
        ...state,
        userEditorData: updateUserEditorData(
          state.userEditorData,
          action.payload
        )
      }

    default:
      return state
  }
}
